module.exports = __webpack_public_path__ + "024.fbde9f8f.png";